import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home.vue'
import Store from '../store/index'

import homeRouter from "./homeRouter"// 首页 票务、讲解、活动三个模块
import volunteerRouter from "./volunteerRouter"// 志愿者模块
import haibotangRouter from "./shoppingRouter"// 海博堂模块

import introductoryArticlesRouter from "./introductoryArticles" //海南文博
import headlinesRouter from "./new" //海博头条
import complaintRouter from "./complaint" //投诉建议
import personalCenterRouter from "./personalCenter" //个人中心


Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      hasTabbar: true,
      barIndex: 0,
    }
  },
  {
    path: '*',
    name: 'error',
    component: () => import('../views/error.vue'),
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/About.vue'),
  //   meta: {
  //     hasTabbar: true
  //   }
  // },
  ...homeRouter,
  ...volunteerRouter,
  ...haibotangRouter,

  ...introductoryArticlesRouter,
  ...headlinesRouter,
  ...complaintRouter,
  ...personalCenterRouter,
]

const router = new VueRouter({
  // mode: 'history',  //去掉url中的#
  routes
})

router.beforeEach((to, from, next) => {

  // var ua = navigator.userAgent.toLowerCase();
  // var isWeixin = ua.indexOf('micromessenger') != -1;
  // var isAndroid = ua.indexOf('android') != -1;
  // var isIos = (ua.indexOf('iphone') != -1) || (ua.indexOf('ipad') != -1);
  // if (!isWeixin) {
  //   document.head.innerHTML = '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">';
  //   document.body.innerHTML = '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>';
  // }

  // switch (to.name) {
  //   case 'personalCenter':
  //     if(!Store.state.userInfo.isBind){
  //       router.push({ path: 'settingPage' })
  //     }
  //     break;
  //   default:
  //     break;
  // }
  // next()

  // //  严格校验用户是否绑定用户信息
  // let {
  //   name = ''
  // } = to;
  // if(name === 'settingPage' || name === 'Home' || name === 'test'){
  //   next()
  // }else if(!Store.state.userInfo.isBind){
  //   router.push({ path: 'settingPage' })
  // }else{
  //   next()
  // }
  next()

})


router.afterEach((to) => {
  let { hasTabbar = false, title = '海南省博物馆', barIndex = 10 } = to.meta;
  window.scrollTo(0, 0);
  if (title) window.document.title = title
  Store.commit('setTabbar', hasTabbar)
  Store.commit('setBarActive', barIndex)
})

export default router
